import { Union, Record } from "../fable_modules/fable-library-js.4.29.0/Types.js";
import { union_type, array_type, class_type, int32_type, string_type, record_type, bool_type, option_type } from "../fable_modules/fable-library-js.4.29.0/Reflection.js";
import { Role, UpdatedEvent, Region_$reflection, User_$reflection } from "../Shared/SharedModels.jsx";
import { tap, PromiseBuilder__TryFinally_7D49A2FD, PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "../fable_modules/Fable.Promise.3.2.0/Promise.fs.js";
import { promise } from "../fable_modules/Fable.Promise.3.2.0/PromiseImpl.fs.js";
import { successToast, errorToast } from "../Toasts.jsx";
import { startAsPromise } from "../fable_modules/fable-library-js.4.29.0/Async.js";
import { Event$, toastServerError, Region, User } from "../ApiClient.jsx";
import { Result_ToOption } from "../fable_modules/fable-library-js.4.29.0/Result.js";
import { orElseWith, toArray, map as map_1, defaultArg, orElse, map2 } from "../fable_modules/fable-library-js.4.29.0/Option.js";
import { append as append_1, contains, sortBy, tryFind, equalsWith, map } from "../fable_modules/fable-library-js.4.29.0/Array.js";
import { useCtx, ContextMsg } from "../Context.jsx";
import { toString, minute, hour, day, month, year, create, utcNow, compare, equals as equals_1, toUniversalTime } from "../fable_modules/fable-library-js.4.29.0/Date.js";
import { createElement } from "react";
import React from "react";
import { Spinner, Textarea, Avatar, Input, Divider, Switch, SpinButton, Text as Text$, Option, Dropdown, Field, DialogContent, Caption1, Title3, DialogTitle, DialogBody, DialogSurface, Button, DialogTrigger, Dialog as Dialog_1, Caption1Strong, tokens, Image } from "@fluentui/react-components";
import { numberHash, comparePrimitives, equals, createObj } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { WarningRegular, DismissRegular, EditRegular, CalendarLtrRegular } from "@fluentui/react-icons";
import { reactApi } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { empty as empty_1, singleton as singleton_1, ofArray } from "../fable_modules/fable-library-js.4.29.0/List.js";
import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.29.0/String.js";
import { ScreenSize, useFeliz_React__React_useResponsive_Static_Z434A9929 } from "../fable_modules/Feliz.UseMediaQuery.1.5.0/UseMediaQuery.fs.js";
import { take, length, map as map_2, empty, forAll, iterate, tryHead, singleton, append, delay, toList } from "../fable_modules/fable-library-js.4.29.0/Seq.js";
import { reactApi as reactApi_1 } from "../fable_modules/Feliz.2.9.0/Interop.fs.js";
import { defaultOf } from "../fable_modules/fable-library-js.4.29.0/Util.js";
import { isNumber } from "../fable_modules/fable-library-js.4.29.0/Char.js";
import { parse } from "../fable_modules/fable-library-js.4.29.0/Int32.js";
import { Component } from "../AddressSearch.jsx";
import { datePickerStrings, UserSearchBox } from "../Helpers.jsx";
import { DatePicker } from "@fluentui/react-datepicker-compat";
import { nb } from "date-fns/locale";
import { setHours, format as format_3 } from "date-fns";
import { TimePicker } from "@fluentui/react-timepicker-compat";
import { TimeSelectionDataModule_parse } from "../fable_modules/FS.FluentUI.3.0.0/Domain.fs.js";

class Model extends Record {
    constructor(Form, Prerequisites, IsOpen, IsSending, IsFetchingPrerequisites) {
        super();
        this.Form = Form;
        this.Prerequisites = Prerequisites;
        this.IsOpen = IsOpen;
        this.IsSending = IsSending;
        this.IsFetchingPrerequisites = IsFetchingPrerequisites;
    }
}

function Model_$reflection() {
    return record_type("EditEvent.Model", [], Model, () => [["Form", UpdatedEventForm_$reflection()], ["Prerequisites", option_type(EventPrerequisites_$reflection())], ["IsOpen", bool_type], ["IsSending", bool_type], ["IsFetchingPrerequisites", bool_type]]);
}

class UpdatedEventForm extends Record {
    constructor(Name, Enabled, Summary, Description, Address, MaxAttendees, Time, EndTime, SignupDeadline, DateDescription, TeacherId, SecondaryTeacherIds, RegionId) {
        super();
        this.Name = Name;
        this.Enabled = Enabled;
        this.Summary = Summary;
        this.Description = Description;
        this.Address = Address;
        this.MaxAttendees = (MaxAttendees | 0);
        this.Time = Time;
        this.EndTime = EndTime;
        this.SignupDeadline = SignupDeadline;
        this.DateDescription = DateDescription;
        this.TeacherId = TeacherId;
        this.SecondaryTeacherIds = SecondaryTeacherIds;
        this.RegionId = (RegionId | 0);
    }
}

function UpdatedEventForm_$reflection() {
    return record_type("EditEvent.UpdatedEventForm", [], UpdatedEventForm, () => [["Name", string_type], ["Enabled", bool_type], ["Summary", string_type], ["Description", option_type(string_type)], ["Address", string_type], ["MaxAttendees", int32_type], ["Time", class_type("System.DateTime")], ["EndTime", class_type("System.DateTime")], ["SignupDeadline", class_type("System.DateTime")], ["DateDescription", option_type(string_type)], ["TeacherId", option_type(int32_type)], ["SecondaryTeacherIds", array_type(int32_type)], ["RegionId", int32_type]]);
}

class EventPrerequisites extends Record {
    constructor(AllTeachers, AllRegions) {
        super();
        this.AllTeachers = AllTeachers;
        this.AllRegions = AllRegions;
    }
}

function EventPrerequisites_$reflection() {
    return record_type("EditEvent.EventPrerequisites", [], EventPrerequisites, () => [["AllTeachers", array_type(User_$reflection())], ["AllRegions", array_type(Region_$reflection())]]);
}

class Msg extends Union {
    constructor(tag, fields) {
        super();
        this.tag = tag;
        this.fields = fields;
    }
    cases() {
        return ["UpdateForm", "UpdatePrerequisites", "UpdateIsOpen", "UpdateIsSending", "UpdateIsFetchingPrerequisites"];
    }
}

function Msg_$reflection() {
    return union_type("EditEvent.Msg", [], Msg, () => [[["Item", UpdatedEventForm_$reflection()]], [["Item", option_type(EventPrerequisites_$reflection())]], [["Item", bool_type]], [["Item", bool_type]], [["Item", bool_type]]]);
}

function update(model, msg) {
    switch (msg.tag) {
        case 1:
            return new Model(model.Form, msg.fields[0], model.IsOpen, model.IsSending, model.IsFetchingPrerequisites);
        case 2:
            return new Model(model.Form, model.Prerequisites, msg.fields[0], model.IsSending, model.IsFetchingPrerequisites);
        case 3:
            return new Model(model.Form, model.Prerequisites, model.IsOpen, msg.fields[0], model.IsFetchingPrerequisites);
        case 4:
            return new Model(model.Form, model.Prerequisites, model.IsOpen, model.IsSending, msg.fields[0]);
        default:
            return new Model(msg.fields[0], model.Prerequisites, model.IsOpen, model.IsSending, model.IsFetchingPrerequisites);
    }
}

function init(form) {
    return new Model(form, undefined, false, false, true);
}

function Promises_fetchPrerequisites(dispatch, setCtx) {
    let pr_3;
    const pr_2 = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => PromiseBuilder__TryFinally_7D49A2FD(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let pr, pr_1;
        return (Promise.all([((pr = tap((res) => {
            if (res.tag === 1) {
                errorToast(setCtx, "fetchUsersError", "Kunne ikke hente brukere", "", undefined);
            }
        }, startAsPromise(User.GetAllTeachers())), pr.then(Result_ToOption))), ((pr_1 = tap((res_1) => {
            if (res_1.tag === 1) {
                errorToast(setCtx, "fetchRegionsError", "Kunne ikke hente regioner", "", undefined);
            }
        }, startAsPromise(Region.GetEnabledRegions())), pr_1.then(Result_ToOption)))])).then((_arg) => {
            dispatch(new Msg(1, [map2((users$0027, regions$0027) => (new EventPrerequisites(users$0027, regions$0027)), _arg[0], _arg[1])]));
            return Promise.resolve();
        });
    }), () => {
        dispatch(new Msg(4, [false]));
    })));
    pr_3 = (pr_2.catch((ex) => {
        toastServerError(setCtx, ex);
    }));
    void pr_3;
}

function Promises_updateEvent(eventId, form, updateEvent, dispatch, setCtx) {
    const matchValue = form.TeacherId;
    if (matchValue != null) {
        const teacherId = matchValue | 0;
        const pr = tap((res) => {
            let tupledArg;
            dispatch(new Msg(3, [false]));
            if (res.tag === 1) {
                switch (res.fields[0].tag) {
                    case 1: {
                        errorToast(setCtx, "updateEventNegativeMaxAttendees", "Kunne ikke oppdatere arrangement", "Antall plasser kan ikke være negativt", undefined);
                        break;
                    }
                    case 2: {
                        errorToast(setCtx, "updateEventEmptyName", "Kunne ikke oppdatere arrangement", "Navn kan ikke være tomt", undefined);
                        break;
                    }
                    case 3: {
                        errorToast(setCtx, "updateEventEmptySummary", "Kunne ikke oppdatere arrangement", "Sammendrag kan ikke være tomt", undefined);
                        break;
                    }
                    case 4: {
                        errorToast(setCtx, "updateEventEmptyAddress", "Kunne ikke oppdatere arrangement", "Adresse kan ikke være tom", undefined);
                        break;
                    }
                    case 5: {
                        errorToast(setCtx, "updateEventInvalidTeacher", "Kunne ikke oppdatere arrangement", "Ugyldig kursholder", undefined);
                        break;
                    }
                    case 6: {
                        errorToast(setCtx, "updateEventTeacherIsAttendee", "Kunne ikke oppdatere arrangement", "Kursholder kan ikke være deltaker på arrangementet", undefined);
                        break;
                    }
                    case 7: {
                        errorToast(setCtx, "updateEventInvalidRegion", "Kunne ikke oppdatere arrangement", "Ugyldig region", undefined);
                        break;
                    }
                    case 8: {
                        errorToast(setCtx, "updateEventInvalidTime", "Kunne ikke oppdatere arrangement", "Ugyldig tid/dato", undefined);
                        break;
                    }
                    case 9: {
                        errorToast(setCtx, "updateEventInvalidDeadline", "Kunne ikke oppdatere arrangement", "Ugyldig påmeldingsfrist", undefined);
                        break;
                    }
                    case 10: {
                        errorToast(setCtx, "updateEventInvalidSecondaryTeacher", "Kunne ikke oppdatere arrangement", "Ugyldig sekundær kursholder", undefined);
                        break;
                    }
                    case 11: {
                        errorToast(setCtx, "updateEventPrimaryTeacherInSecondaryList", "Kunne ikke oppdatere arrangement", "Primær kursholder kan ikke være sekundær kursholder", undefined);
                        break;
                    }
                    default:
                        errorToast(setCtx, "updateEventNotFound", "Kunne ikke oppdatere arrangement", "Kunne ikke finne arrangement å oppdatere", undefined);
                }
            }
            else {
                const e = res.fields[0];
                updateEvent(e);
                successToast(setCtx, "updateEventSuccess", "Arrangement oppdatert", `Arrangementet ${e.Name} ble oppdatert`);
                dispatch(new Msg(2, [false]));
                dispatch(new Msg(0, [new UpdatedEventForm(e.Name, e.Enabled, e.Summary, e.Description, e.Address, e.MaxAttendees, e.Time, e.EndTime, e.SignupDeadline, e.DateDescription, e.Teacher.Id, map((_arg) => _arg.Id, e.SecondaryTeachers, Int32Array), e.Region.Id)]));
                setCtx((tupledArg = [e.Id, e.Name], new ContextMsg(7, [tupledArg[0], tupledArg[1]])));
            }
        }, startAsPromise(Event$.Update(eventId, new UpdatedEvent(form.Name, form.Enabled, form.Summary, form.Description, form.Address, form.MaxAttendees, toUniversalTime(form.Time), toUniversalTime(form.EndTime), toUniversalTime(form.SignupDeadline), form.DateDescription, teacherId, form.SecondaryTeacherIds, form.RegionId))));
        void (pr.catch((arg) => {
            const _arg_1 = toastServerError(setCtx, arg);
            dispatch(new Msg(3, [false]));
        }));
    }
    else {
        errorToast(setCtx, "updateEventFormNotFilled", "Kunne ikke oppdatere arrangement", "Kursholder må fylles inn", undefined);
        dispatch(new Msg(3, [false]));
    }
}

function Hero(course) {
    let elems, el_2;
    const matchValue = orElse(course.ImageUrl, course.ThumbnailUrl);
    let matchResult, url_1;
    if (matchValue != null) {
        if (!isNullOrWhiteSpace(matchValue)) {
            matchResult = 0;
            url_1 = matchValue;
        }
        else {
            matchResult = 1;
        }
    }
    else {
        matchResult = 1;
    }
    switch (matchResult) {
        case 0: {
            const el = Image;
            return createElement(el, {
                style: {
                    display: "block",
                    width: 100 + "%",
                    height: 180,
                    objectFit: "cover",
                    flexShrink: 0,
                },
                src: url_1,
                fit: "cover",
            });
        }
        default:
            return createElement("div", createObj(ofArray([["style", {
                height: 180,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                backgroundColor: tokens.colorNeutralBackground3,
                flexShrink: 0,
            }], (elems = [(el_2 = CalendarLtrRegular, createElement(el_2, {
                style: {
                    fontSize: 96 + "px",
                },
                primaryFill: tokens.colorNeutralForeground3,
            }))], ["children", reactApi.Children.toArray(Array.from(elems))])])));
    }
}

function SectionEyebrow(sectionEyebrowInputProps) {
    const label = sectionEyebrowInputProps.label;
    const el = Caption1Strong;
    return createElement(el, {
        style: {
            display: "block",
            textTransform: "uppercase",
            letterSpacing: "0.6px",
            color: tokens.colorNeutralForeground3,
            marginTop: 4,
        },
        children: label,
    });
}

export function Dialog(dialogInputProps) {
    let elems_50, el_4, el_2, el, el_116, elems_49, elems_46, el_106, elems_45, el_10, elems_1, elems, el_6, el_8, el_104, elems_44, elems_48, el_108, el_114, elems_47, elemsToUse;
    const replaceEvent = dialogInputProps.replaceEvent;
    const event = dialogInputProps.event;
    const setCtx = useCtx()[1];
    const initialForm = new UpdatedEventForm(event.Name, event.Enabled, event.Summary, event.Description, event.Address, event.MaxAttendees, event.Time, event.EndTime, event.SignupDeadline, event.DateDescription, event.Teacher.Id, map((_arg) => _arg.Id, event.SecondaryTeachers, Int32Array), event.Region.Id);
    let patternInput_1;
    const arg_1 = init(initialForm);
    patternInput_1 = reactApi.useReducer(update, arg_1);
    const model_1 = patternInput_1[0];
    const dispatch = patternInput_1[1];
    const screenSize = useFeliz_React__React_useResponsive_Static_Z434A9929();
    const isMobile = equals(screenSize, new ScreenSize(0, [])) ? true : equals(screenSize, new ScreenSize(1, []));
    const canSubmit = ((((((((((!((((((((((((model_1.Form.MaxAttendees === event.MaxAttendees) && (model_1.Form.Name === event.Name)) && (model_1.Form.Summary === event.Summary)) && equals(model_1.Form.Description, event.Description)) && (model_1.Form.Enabled === event.Enabled)) && (model_1.Form.Address === event.Address)) && equals_1(toUniversalTime(model_1.Form.Time), toUniversalTime(event.Time))) && equals_1(toUniversalTime(model_1.Form.EndTime), toUniversalTime(event.EndTime))) && (model_1.Form.RegionId === event.Region.Id)) && defaultArg(map_1((teacherId) => (teacherId === event.Teacher.Id), model_1.Form.TeacherId), false)) && equalsWith((x, y) => (x === y), model_1.Form.SecondaryTeacherIds, map((_arg_1) => _arg_1.Id, event.SecondaryTeachers, Int32Array))) && equals(model_1.Form.DateDescription, event.DateDescription)) && !isNullOrWhiteSpace(model_1.Form.Name)) && !isNullOrWhiteSpace(model_1.Form.Summary)) && (model_1.Form.Summary.length <= 200)) && defaultArg(map_1((d) => (d.length <= 5000), model_1.Form.Description), true)) && defaultArg(map_1((d_1) => (d_1.length <= 5000), model_1.Form.DateDescription), true)) && !isNullOrWhiteSpace(model_1.Form.Address)) && (model_1.Form.MaxAttendees > 0)) && (model_1.Form.MaxAttendees <= 1000)) && (model_1.Form.TeacherId != null)) && (compare(model_1.Form.SignupDeadline, model_1.Form.Time) < 0)) && !model_1.IsSending;
    const el_118 = Dialog_1;
    return createElement(el_118, createObj(ofArray([["open", model_1.IsOpen], ["onOpenChange", (_arg_2, value_1_2) => {
        dispatch(new Msg(2, [value_1_2.open]));
    }], (elems_50 = [(el_4 = DialogTrigger, createElement(el_4, {
        children: (el_2 = Button, createElement(el_2, {
            children: "Rediger",
            icon: (el = EditRegular, createElement(el, {})),
            appearance: "primary",
            disabled: event.Finalized,
            onClick: (_arg_3) => {
                if (model_1.Prerequisites == null) {
                    Promises_fetchPrerequisites(dispatch, setCtx);
                }
            },
        })),
    })), (el_116 = DialogSurface, createElement(el_116, createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["padding", 0]), delay(() => append(singleton(["overflow", "hidden"]), delay(() => append(singleton(["maxHeight", 90 + "vh"]), delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["flexDirection", "column"]), delay(() => (isMobile ? singleton(["width", 95 + "vw"]) : append(singleton(["minWidth", 720]), delay(() => singleton(["maxWidth", 760])))))))))))))))))], (elems_49 = [createElement(Hero, event.Course), createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        flexGrow: 1,
        minHeight: 0,
        overflowY: "auto",
    }], (elems_46 = [(el_106 = DialogBody, createElement(el_106, createObj(ofArray([["style", {
        padding: ((16 + "px ") + 18) + "px",
        gap: 14 + "px ",
    }], (elems_45 = [(el_10 = DialogTitle, createElement(el_10, createObj(singleton_1((elems_1 = [createElement("div", createObj(ofArray([["style", {
        display: "flex",
        flexDirection: "column",
        gap: 4 + "px ",
    }], (elems = [(el_6 = Title3, createElement(el_6, {
        children: "Rediger arrangement",
    })), (el_8 = Caption1, createElement(el_8, {
        style: {
            color: tokens.colorNeutralForeground3,
        },
        children: event.Course.Name,
    }))], ["children", reactApi.Children.toArray(Array.from(elems))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_1))]))))), (el_104 = DialogContent, createElement(el_104, createObj(ofArray([["style", {
        overflow: "visible",
    }], (elems_44 = toList(delay(() => {
        let elems_43, elems_36, elems_35, elems_42, elems_41, elems_38, el_97, elems_40, el_102, elems_2, el_12, el_14;
        const matchValue = model_1.Prerequisites;
        if (matchValue != null) {
            const prerequisites = matchValue;
            const allValidTeachers = prerequisites.AllTeachers.filter((u) => {
                if (equals(u.Role, new Role(1, [])) ? true : equals(u.Role, new Role(2, []))) {
                    return true;
                }
                else {
                    return equals(u.Role, new Role(3, []));
                }
            });
            return singleton(createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 18 + "px ",
            }], (elems_43 = [createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 8 + "px ",
            }], (elems_36 = [createElement(SectionEyebrow, {
                label: "Detaljer",
            }), createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(isMobile ? append(singleton(["flexDirection", "column"]), delay(() => singleton(["gap", 10 + "px "]))) : singleton(["flexDirection", "row"]), delay(() => singleton(["width", 100 + "%"]))))))))], (elems_35 = toList(delay(() => {
                let elems_13, elems_6, el_23, matchValue_1, el_20, elems_4, elems_8, el_28, matchValue_2, el_25, elems_10, el_31, elems_12, el_36;
                return append(singleton(createElement("div", createObj(ofArray([["style", {
                    minWidth: 280,
                    display: "flex",
                    flexDirection: "column",
                    gap: 10 + "px ",
                }], (elems_13 = [createElement("div", createObj(ofArray([["style", {
                    height: 70,
                }], (elems_6 = [(el_23 = Field, createElement(el_23, {
                    label: "Region",
                    required: true,
                    children: (matchValue_1 = tryHead([(el_20 = Dropdown, createElement(el_20, createObj(ofArray([["value", defaultArg(map_1((_arg_4) => _arg_4.Name, tryFind((region) => (region.Id === model_1.Form.RegionId), prerequisites.AllRegions)), "")], ["onOptionSelect", (_arg_6, value_1_13) => {
                        iterate((selected) => {
                            let bind$0040;
                            const selectedRegionId = map_1((_arg_5) => _arg_5.Id, tryFind((region_1) => (region_1.Name === selected), prerequisites.AllRegions));
                            if (selectedRegionId != null) {
                                dispatch(new Msg(0, [(bind$0040 = model_1.Form, new UpdatedEventForm(bind$0040.Name, bind$0040.Enabled, bind$0040.Summary, bind$0040.Description, bind$0040.Address, bind$0040.MaxAttendees, bind$0040.Time, bind$0040.EndTime, bind$0040.SignupDeadline, bind$0040.DateDescription, bind$0040.TeacherId, bind$0040.SecondaryTeacherIds, selectedRegionId))]));
                            }
                        }, toArray(value_1_13.optionValue));
                    }], (elems_4 = toList(delay(() => map((region_2) => {
                        let elems_3, el_16;
                        const el_18 = Option;
                        return createElement(el_18, createObj(ofArray([["value", region_2.Name], ["text", region_2.Name], (elems_3 = [(el_16 = Text$, createElement(el_16, {
                            children: region_2.Name,
                        }))], ["children", reactApi_1.Children.toArray(Array.from(elems_3))])])));
                    }, sortBy((_arg_7) => _arg_7.Name, prerequisites.AllRegions, {
                        Compare: comparePrimitives,
                    })))), ["children", reactApi_1.Children.toArray(Array.from(elems_4))])]))))]), (matchValue_1 == null) ? defaultOf() : matchValue_1),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_6))])]))), createElement("div", createObj(ofArray([["style", {
                    height: 70,
                }], (elems_8 = [(el_28 = Field, createElement(el_28, {
                    label: "Antall plasser",
                    required: true,
                    children: (matchValue_2 = tryHead([(el_25 = SpinButton, createElement(el_25, {
                        style: {
                            minWidth: 250,
                        },
                        value: model_1.Form.MaxAttendees,
                        min: 0,
                        max: 1000,
                        onChange: (_arg_8, value_1_21) => {
                            const d_3 = value_1_21;
                            iterate((maxAttendees) => {
                                let bind$0040_1;
                                dispatch(new Msg(0, [(bind$0040_1 = model_1.Form, new UpdatedEventForm(bind$0040_1.Name, bind$0040_1.Enabled, bind$0040_1.Summary, bind$0040_1.Description, bind$0040_1.Address, (maxAttendees < 1000) ? maxAttendees : 1000, bind$0040_1.Time, bind$0040_1.EndTime, bind$0040_1.SignupDeadline, bind$0040_1.DateDescription, bind$0040_1.TeacherId, bind$0040_1.SecondaryTeacherIds, bind$0040_1.RegionId))]));
                            }, toArray(orElseWith(d_3.value, () => {
                                if (isNullOrWhiteSpace(d_3.displayValue)) {
                                    return undefined;
                                }
                                else if (forAll(isNumber, d_3.displayValue.split(""))) {
                                    return parse(d_3.displayValue, 511, false, 32);
                                }
                                else {
                                    return undefined;
                                }
                            })));
                        },
                    }))]), (matchValue_2 == null) ? defaultOf() : matchValue_2),
                }))], ["children", reactApi.Children.toArray(Array.from(elems_8))])]))), createElement("div", createObj(ofArray([["style", {
                    height: 70,
                }], (elems_10 = [(el_31 = Field, createElement(el_31, createObj(toList(delay(() => append(singleton(["label", "Adresse"]), delay(() => append(singleton(["required", true]), delay(() => append(isNullOrWhiteSpace(model_1.Form.Address) ? append(singleton(["validationMessage", "Adressefelt kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
                    let matchValue_3;
                    return singleton(["children", (matchValue_3 = tryHead([createElement(Component, {
                        value: model_1.Form.Address,
                        onChange: (v_1) => {
                            let bind$0040_2;
                            dispatch(new Msg(0, [(bind$0040_2 = model_1.Form, new UpdatedEventForm(bind$0040_2.Name, bind$0040_2.Enabled, bind$0040_2.Summary, bind$0040_2.Description, v_1, bind$0040_2.MaxAttendees, bind$0040_2.Time, bind$0040_2.EndTime, bind$0040_2.SignupDeadline, bind$0040_2.DateDescription, bind$0040_2.TeacherId, bind$0040_2.SecondaryTeacherIds, bind$0040_2.RegionId))]));
                        },
                        placeholder: "Skriv inn adresse…",
                        disabled: false,
                    })]), (matchValue_3 == null) ? defaultOf() : matchValue_3)]);
                })))))))))))], ["children", reactApi.Children.toArray(Array.from(elems_10))])]))), createElement("div", createObj(ofArray([["style", {
                    height: 70,
                }], (elems_12 = [(el_36 = Field, createElement(el_36, createObj(toList(delay(() => append(singleton(["label", "Publiser"]), delay(() => append(model_1.Form.Enabled ? singleton(["hint", "Arrangementet publiseres med en gang, og blir synlig for alle"]) : singleton(["hint", "Arrangementet lagres som utkast, og blir ikke synlig for alle"]), delay(() => {
                    let matchValue_4, el_33;
                    return singleton(["children", (matchValue_4 = tryHead([(el_33 = Switch, createElement(el_33, {
                        checked: model_1.Form.Enabled,
                        onChange: (_arg_9, value_1_29) => {
                            let bind$0040_3;
                            dispatch(new Msg(0, [(bind$0040_3 = model_1.Form, new UpdatedEventForm(bind$0040_3.Name, value_1_29.checked, bind$0040_3.Summary, bind$0040_3.Description, bind$0040_3.Address, bind$0040_3.MaxAttendees, bind$0040_3.Time, bind$0040_3.EndTime, bind$0040_3.SignupDeadline, bind$0040_3.DateDescription, bind$0040_3.TeacherId, bind$0040_3.SecondaryTeacherIds, bind$0040_3.RegionId))]));
                        },
                    }))]), (matchValue_4 == null) ? defaultOf() : matchValue_4)]);
                })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_12))])])))], ["children", reactApi.Children.toArray(Array.from(elems_13))])])))), delay(() => {
                    let el_38;
                    return append(!isMobile ? singleton((el_38 = Divider, createElement(el_38, {
                        vertical: true,
                    }))) : empty(), delay(() => {
                        let elems_34, elems_15, el_43, elems_19, el_54, elems_24, el_65, matchValue_8, elems_26, el_70, matchValue_9, el_67, elems_27, el_74, el_72, elems_29, el_79, elems_30, el_83, el_81, elems_31, el_87, el_85, elems_33, el_92;
                        return singleton(createElement("div", createObj(ofArray([["style", createObj(toList(delay(() => append(singleton(["display", "flex"]), delay(() => append(singleton(["flexDirection", "column"]), delay(() => append(singleton(["gap", 10 + "px "]), delay(() => (!isMobile ? singleton(["width", 280]) : empty()))))))))))], (elems_34 = [createElement("div", createObj(ofArray([["style", {
                            height: 70,
                        }], (elems_15 = [(el_43 = Field, createElement(el_43, createObj(toList(delay(() => append(singleton(["label", "Navn"]), delay(() => append(singleton(["required", true]), delay(() => append(isNullOrWhiteSpace(model_1.Form.Name) ? append(singleton(["validationMessage", "Navn kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
                            let matchValue_5, el_40;
                            return singleton(["children", (matchValue_5 = tryHead([(el_40 = Input, createElement(el_40, {
                                style: {
                                    minWidth: 250,
                                },
                                value: model_1.Form.Name,
                                onChange: (_arg_10, value_1_35) => {
                                    let bind$0040_4;
                                    dispatch(new Msg(0, [(bind$0040_4 = model_1.Form, new UpdatedEventForm(value_1_35.value, bind$0040_4.Enabled, bind$0040_4.Summary, bind$0040_4.Description, bind$0040_4.Address, bind$0040_4.MaxAttendees, bind$0040_4.Time, bind$0040_4.EndTime, bind$0040_4.SignupDeadline, bind$0040_4.DateDescription, bind$0040_4.TeacherId, bind$0040_4.SecondaryTeacherIds, bind$0040_4.RegionId))]));
                                },
                            }))]), (matchValue_5 == null) ? defaultOf() : matchValue_5)]);
                        })))))))))))], ["children", reactApi.Children.toArray(Array.from(elems_15))])]))), createElement("div", createObj(ofArray([["style", {
                            height: 70,
                        }], (elems_19 = [(el_54 = Field, createElement(el_54, createObj(toList(delay(() => append(singleton(["label", "Kursholder"]), delay(() => append(singleton(["required", true]), delay(() => append((model_1.Form.TeacherId == null) ? append(singleton(["validationMessage", "Arrangementet må ha en kursholder"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
                            let matchValue_7;
                            return singleton(["children", (matchValue_7 = tryHead(toList(delay(() => {
                                let elems_17, elems_16, el_45, el_47, el_51, el_49;
                                const matchValue_6 = tryFind((user) => equals(user.Id, model_1.Form.TeacherId), prerequisites.AllTeachers);
                                if (matchValue_6 != null) {
                                    const teacher$0027 = matchValue_6;
                                    return singleton(createElement("div", createObj(ofArray([["style", {
                                        display: "flex",
                                        justifyContent: "space-between",
                                        minWidth: 250,
                                    }], (elems_17 = [createElement("div", createObj(ofArray([["style", {
                                        display: "flex",
                                        gap: 5 + "px ",
                                        alignItems: "center",
                                    }], (elems_16 = [(el_45 = Avatar, createElement(el_45, {
                                        color: "colorful",
                                        image: {
                                            src: defaultArg(teacher$0027.ImageUrl, ""),
                                        },
                                        name: `${teacher$0027.FirstName} ${teacher$0027.LastName}`,
                                    })), (el_47 = Text$, createElement(el_47, {
                                        children: `${teacher$0027.FirstName} ${teacher$0027.LastName}`,
                                    }))], ["children", reactApi.Children.toArray(Array.from(elems_16))])]))), (el_51 = Button, createElement(el_51, {
                                        appearance: "transparent",
                                        icon: (el_49 = DismissRegular, createElement(el_49, {})),
                                        onClick: (_arg_11) => {
                                            let bind$0040_6;
                                            dispatch(new Msg(0, [(bind$0040_6 = model_1.Form, new UpdatedEventForm(bind$0040_6.Name, bind$0040_6.Enabled, bind$0040_6.Summary, bind$0040_6.Description, bind$0040_6.Address, bind$0040_6.MaxAttendees, bind$0040_6.Time, bind$0040_6.EndTime, bind$0040_6.SignupDeadline, bind$0040_6.DateDescription, undefined, bind$0040_6.SecondaryTeacherIds, bind$0040_6.RegionId))]));
                                        },
                                    }))], ["children", reactApi.Children.toArray(Array.from(elems_17))])]))));
                                }
                                else {
                                    return singleton(createElement(UserSearchBox, {
                                        users: allValidTeachers,
                                        callback: (user_1) => {
                                            let bind$0040_5;
                                            dispatch(new Msg(0, [(bind$0040_5 = model_1.Form, new UpdatedEventForm(bind$0040_5.Name, bind$0040_5.Enabled, bind$0040_5.Summary, bind$0040_5.Description, bind$0040_5.Address, bind$0040_5.MaxAttendees, bind$0040_5.Time, bind$0040_5.EndTime, bind$0040_5.SignupDeadline, bind$0040_5.DateDescription, user_1.Id, bind$0040_5.SecondaryTeacherIds, bind$0040_5.RegionId))]));
                                        },
                                    }));
                                }
                            }))), (matchValue_7 == null) ? defaultOf() : matchValue_7)]);
                        })))))))))))], ["children", reactApi.Children.toArray(Array.from(elems_19))])]))), createElement("div", createObj(ofArray([["style", {
                            minHeight: 100,
                            width: 100 + "%",
                        }], (elems_24 = [(el_65 = Field, createElement(el_65, {
                            label: "Sekundære kursholdere (valgfritt)",
                            children: (matchValue_8 = tryHead(toList(delay(() => {
                                let elems_22;
                                const selectedSecondaryTeachers = prerequisites.AllTeachers.filter((user_2) => contains(user_2.Id, model_1.Form.SecondaryTeacherIds, {
                                    Equals: (x_2, y_2) => (x_2 === y_2),
                                    GetHashCode: numberHash,
                                }));
                                return singleton(createElement("div", createObj(ofArray([["style", {
                                    display: "flex",
                                    flexDirection: "column",
                                    gap: 5 + "px ",
                                }], (elems_22 = toList(delay(() => append(map_2((teacher_1) => {
                                    let elems_21, elems_20, el_56, el_58, el_62, el_60;
                                    return createElement("div", createObj(ofArray([["style", {
                                        display: "flex",
                                        justifyContent: "space-between",
                                        alignItems: "center",
                                        backgroundColor: tokens.colorNeutralBackground1,
                                    }], (elems_21 = [createElement("div", createObj(ofArray([["style", {
                                        display: "flex",
                                        gap: 8 + "px ",
                                        alignItems: "center",
                                    }], (elems_20 = [(el_56 = Avatar, createElement(el_56, {
                                        color: "colorful",
                                        size: 28,
                                        image: {
                                            src: defaultArg(teacher_1.ThumbnailUrl, ""),
                                        },
                                        name: `${teacher_1.FirstName} ${teacher_1.LastName}`,
                                    })), (el_58 = Text$, createElement(el_58, {
                                        children: `${teacher_1.FirstName} ${teacher_1.LastName}`,
                                    }))], ["children", reactApi.Children.toArray(Array.from(elems_20))])]))), (el_62 = Button, createElement(el_62, {
                                        appearance: "transparent",
                                        icon: (el_60 = DismissRegular, createElement(el_60, {})),
                                        onClick: (_arg_12) => {
                                            let bind$0040_7;
                                            dispatch(new Msg(0, [(bind$0040_7 = model_1.Form, new UpdatedEventForm(bind$0040_7.Name, bind$0040_7.Enabled, bind$0040_7.Summary, bind$0040_7.Description, bind$0040_7.Address, bind$0040_7.MaxAttendees, bind$0040_7.Time, bind$0040_7.EndTime, bind$0040_7.SignupDeadline, bind$0040_7.DateDescription, bind$0040_7.TeacherId, model_1.Form.SecondaryTeacherIds.filter((id) => (id !== teacher_1.Id)), bind$0040_7.RegionId))]));
                                        },
                                    }))], ["children", reactApi.Children.toArray(Array.from(elems_21))])])));
                                }, selectedSecondaryTeachers), delay(() => {
                                    const availableTeachers = allValidTeachers.filter((user_3) => {
                                        if (!contains(user_3.Id, model_1.Form.SecondaryTeacherIds, {
                                            Equals: (x_3, y_3) => (x_3 === y_3),
                                            GetHashCode: numberHash,
                                        })) {
                                            return !equals(user_3.Id, model_1.Form.TeacherId);
                                        }
                                        else {
                                            return false;
                                        }
                                    });
                                    return (availableTeachers.length > 0) ? singleton(createElement(UserSearchBox, {
                                        users: availableTeachers,
                                        callback: (user_4) => {
                                            let bind$0040_8;
                                            dispatch(new Msg(0, [(bind$0040_8 = model_1.Form, new UpdatedEventForm(bind$0040_8.Name, bind$0040_8.Enabled, bind$0040_8.Summary, bind$0040_8.Description, bind$0040_8.Address, bind$0040_8.MaxAttendees, bind$0040_8.Time, bind$0040_8.EndTime, bind$0040_8.SignupDeadline, bind$0040_8.DateDescription, bind$0040_8.TeacherId, append_1(model_1.Form.SecondaryTeacherIds, new Int32Array([user_4.Id]), Int32Array), bind$0040_8.RegionId))]));
                                        },
                                    })) : empty();
                                })))), ["children", reactApi.Children.toArray(Array.from(elems_22))])]))));
                            }))), (matchValue_8 == null) ? defaultOf() : matchValue_8),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_24))])]))), createElement("div", createObj(ofArray([["style", {
                            height: 70,
                        }], (elems_26 = [(el_70 = Field, createElement(el_70, {
                            label: "Startdato",
                            required: true,
                            children: (matchValue_9 = tryHead([(el_67 = DatePicker, createElement(el_67, {
                                strings: datePickerStrings,
                                firstDayOfWeek: 1,
                                formatDate: (delegateArg) => {
                                    const locale = nb;
                                    const formatOptions = {};
                                    formatOptions.locale = locale;
                                    return format_3(delegateArg, "EEEE dd MMMM yyyy", formatOptions);
                                },
                                minDate: setHours(utcNow(), 0),
                                value: model_1.Form.Time,
                                onSelectDate: (delegateArg_1) => {
                                    iterate((date_2) => {
                                        let bind$0040_9;
                                        dispatch(new Msg(0, [(bind$0040_9 = model_1.Form, new UpdatedEventForm(bind$0040_9.Name, bind$0040_9.Enabled, bind$0040_9.Summary, bind$0040_9.Description, bind$0040_9.Address, bind$0040_9.MaxAttendees, create(year(date_2), month(date_2), day(date_2), hour(model_1.Form.Time), minute(model_1.Form.Time), 0), bind$0040_9.EndTime, bind$0040_9.SignupDeadline, bind$0040_9.DateDescription, bind$0040_9.TeacherId, bind$0040_9.SecondaryTeacherIds, bind$0040_9.RegionId))]));
                                    }, toArray(delegateArg_1));
                                },
                            }))]), (matchValue_9 == null) ? defaultOf() : matchValue_9),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_26))])]))), createElement("div", createObj(ofArray([["style", {
                            height: 70,
                        }], (elems_27 = [(el_74 = Field, createElement(el_74, {
                            required: true,
                            label: "Starttidspunkt",
                            children: (el_72 = TimePicker, createElement(el_72, {
                                hourCycle: "h23",
                                increment: 15,
                                selectedTime: model_1.Form.Time,
                                value: toString(model_1.Form.Time, "HH:mm"),
                                onTimeChange: (_arg_14, value_1_60) => {
                                    iterate((time) => {
                                        let bind$0040_10;
                                        dispatch(new Msg(0, [(bind$0040_10 = model_1.Form, new UpdatedEventForm(bind$0040_10.Name, bind$0040_10.Enabled, bind$0040_10.Summary, bind$0040_10.Description, bind$0040_10.Address, bind$0040_10.MaxAttendees, create(year(model_1.Form.Time), month(model_1.Form.Time), day(model_1.Form.Time), hour(time), minute(time), 0), bind$0040_10.EndTime, bind$0040_10.SignupDeadline, bind$0040_10.DateDescription, bind$0040_10.TeacherId, bind$0040_10.SecondaryTeacherIds, bind$0040_10.RegionId))]));
                                    }, toArray(TimeSelectionDataModule_parse(value_1_60).selectedTime));
                                },
                            })),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_27))])]))), createElement("div", createObj(ofArray([["style", {
                            height: 70,
                        }], (elems_29 = [(el_79 = Field, createElement(el_79, createObj(toList(delay(() => append(singleton(["label", "Sluttdato"]), delay(() => append(singleton(["required", true]), delay(() => append((compare(model_1.Form.Time, model_1.Form.EndTime) > 0) ? append(singleton(["validationMessage", "Arrangementet kan avslutte før startdato"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
                            let matchValue_10, el_76;
                            return singleton(["children", (matchValue_10 = tryHead([(el_76 = DatePicker, createElement(el_76, {
                                strings: datePickerStrings,
                                firstDayOfWeek: 1,
                                formatDate: (delegateArg_2) => {
                                    const locale_1 = nb;
                                    const formatOptions_1 = {};
                                    formatOptions_1.locale = locale_1;
                                    return format_3(delegateArg_2, "EEEE dd MMMM yyyy", formatOptions_1);
                                },
                                minDate: model_1.Form.Time,
                                value: model_1.Form.EndTime,
                                onSelectDate: (delegateArg_3) => {
                                    iterate((date_4) => {
                                        let bind$0040_11;
                                        dispatch(new Msg(0, [(bind$0040_11 = model_1.Form, new UpdatedEventForm(bind$0040_11.Name, bind$0040_11.Enabled, bind$0040_11.Summary, bind$0040_11.Description, bind$0040_11.Address, bind$0040_11.MaxAttendees, bind$0040_11.Time, create(year(date_4), month(date_4), day(date_4), hour(model_1.Form.EndTime), minute(model_1.Form.EndTime), 0), bind$0040_11.SignupDeadline, bind$0040_11.DateDescription, bind$0040_11.TeacherId, bind$0040_11.SecondaryTeacherIds, bind$0040_11.RegionId))]));
                                    }, toArray(delegateArg_3));
                                },
                            }))]), (matchValue_10 == null) ? defaultOf() : matchValue_10)]);
                        })))))))))))], ["children", reactApi.Children.toArray(Array.from(elems_29))])]))), createElement("div", createObj(ofArray([["style", {
                            height: 70,
                        }], (elems_30 = [(el_83 = Field, createElement(el_83, {
                            required: true,
                            label: "Slutttidspunkt",
                            children: (el_81 = TimePicker, createElement(el_81, {
                                hourCycle: "h23",
                                increment: 15,
                                selectedTime: model_1.Form.EndTime,
                                value: toString(model_1.Form.EndTime, "HH:mm"),
                                onTimeChange: (_arg_16, value_1_75) => {
                                    iterate((time_1) => {
                                        let bind$0040_12;
                                        dispatch(new Msg(0, [(bind$0040_12 = model_1.Form, new UpdatedEventForm(bind$0040_12.Name, bind$0040_12.Enabled, bind$0040_12.Summary, bind$0040_12.Description, bind$0040_12.Address, bind$0040_12.MaxAttendees, bind$0040_12.Time, create(year(model_1.Form.EndTime), month(model_1.Form.EndTime), day(model_1.Form.EndTime), hour(time_1), minute(time_1), 0), bind$0040_12.SignupDeadline, bind$0040_12.DateDescription, bind$0040_12.TeacherId, bind$0040_12.SecondaryTeacherIds, bind$0040_12.RegionId))]));
                                    }, toArray(TimeSelectionDataModule_parse(value_1_75).selectedTime));
                                },
                            })),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_30))])]))), createElement("div", createObj(singleton_1((elems_31 = [(el_87 = Field, createElement(el_87, {
                            label: "Tidsoversikt",
                            children: (el_85 = Textarea, createElement(el_85, {
                                resize: "vertical",
                                value: defaultArg(model_1.Form.DateDescription, ""),
                                onChange: (_arg_17, value_1_79) => {
                                    let bind$0040_13;
                                    const d_5 = value_1_79;
                                    dispatch(new Msg(0, [(bind$0040_13 = model_1.Form, new UpdatedEventForm(bind$0040_13.Name, bind$0040_13.Enabled, bind$0040_13.Summary, bind$0040_13.Description, bind$0040_13.Address, bind$0040_13.MaxAttendees, bind$0040_13.Time, bind$0040_13.EndTime, bind$0040_13.SignupDeadline, (d_5.value === "") ? undefined : d_5.value, bind$0040_13.TeacherId, bind$0040_13.SecondaryTeacherIds, bind$0040_13.RegionId))]));
                                },
                            })),
                        }))], ["children", reactApi.Children.toArray(Array.from(elems_31))])))), createElement("div", createObj(ofArray([["style", {
                            height: 70,
                        }], (elems_33 = [(el_92 = Field, createElement(el_92, createObj(toList(delay(() => append(singleton(["label", "Påmeldingsfrist"]), delay(() => append(singleton(["required", true]), delay(() => append((compare(model_1.Form.SignupDeadline, model_1.Form.Time) >= 0) ? append(singleton(["validationMessage", "Frist kan ikke være etter arrangementet"]), delay(() => singleton(["validationState", "error"]))) : empty(), delay(() => {
                            let matchValue_11, el_89;
                            return singleton(["children", (matchValue_11 = tryHead([(el_89 = DatePicker, createElement(el_89, {
                                strings: datePickerStrings,
                                firstDayOfWeek: 1,
                                formatDate: (delegateArg_4) => {
                                    const locale_2 = nb;
                                    const formatOptions_2 = {};
                                    formatOptions_2.locale = locale_2;
                                    return format_3(delegateArg_4, "EEEE dd MMMM yyyy", formatOptions_2);
                                },
                                minDate: setHours(utcNow(), 0),
                                value: model_1.Form.SignupDeadline,
                                onSelectDate: (delegateArg_5) => {
                                    iterate((date_7) => {
                                        let bind$0040_14;
                                        dispatch(new Msg(0, [(bind$0040_14 = model_1.Form, new UpdatedEventForm(bind$0040_14.Name, bind$0040_14.Enabled, bind$0040_14.Summary, bind$0040_14.Description, bind$0040_14.Address, bind$0040_14.MaxAttendees, bind$0040_14.Time, bind$0040_14.EndTime, create(year(date_7), month(date_7), day(date_7), 23, 59, 59), bind$0040_14.DateDescription, bind$0040_14.TeacherId, bind$0040_14.SecondaryTeacherIds, bind$0040_14.RegionId))]));
                                    }, toArray(delegateArg_5));
                                },
                            }))]), (matchValue_11 == null) ? defaultOf() : matchValue_11)]);
                        })))))))))))], ["children", reactApi.Children.toArray(Array.from(elems_33))])])))], ["children", reactApi.Children.toArray(Array.from(elems_34))])]))));
                    }));
                }));
            })), ["children", reactApi.Children.toArray(Array.from(elems_35))])])))], ["children", reactApi.Children.toArray(Array.from(elems_36))])]))), createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 8 + "px ",
                paddingTop: 14,
                borderTop: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke2,
            }], (elems_42 = [createElement(SectionEyebrow, {
                label: "Beskrivelse",
            }), createElement("div", createObj(ofArray([["style", {
                display: "flex",
                flexDirection: "column",
                gap: 10 + "px ",
                width: 100 + "%",
            }], (elems_41 = [createElement("div", createObj(ofArray([["style", {
                minHeight: 100,
            }], (elems_38 = [(el_97 = Field, createElement(el_97, createObj(toList(delay(() => append(singleton(["label", "Sammendrag"]), delay(() => append(singleton(["required", true]), delay(() => append(isNullOrWhiteSpace(model_1.Form.Summary) ? append(singleton(["validationMessage", "Sammendrag kan ikke være tomt"]), delay(() => singleton(["validationState", "error"]))) : ((model_1.Form.Summary.length > 200) ? append(singleton(["validationMessage", `Sammendrag kan ikke være lengre enn 200 tegn (${model_1.Form.Summary.length}/200)`]), delay(() => singleton(["validationState", "error"]))) : append(singleton(["validationMessage", `${model_1.Form.Summary.length}/200`]), delay(() => singleton(["validationState", "none"])))), delay(() => {
                let matchValue_12, el_94;
                return singleton(["children", (matchValue_12 = tryHead([(el_94 = Textarea, createElement(el_94, {
                    resize: "vertical",
                    value: model_1.Form.Summary,
                    onChange: (_arg_19, value_1_95) => {
                        let bind$0040_15;
                        dispatch(new Msg(0, [(bind$0040_15 = model_1.Form, new UpdatedEventForm(bind$0040_15.Name, bind$0040_15.Enabled, value_1_95.value, bind$0040_15.Description, bind$0040_15.Address, bind$0040_15.MaxAttendees, bind$0040_15.Time, bind$0040_15.EndTime, bind$0040_15.SignupDeadline, bind$0040_15.DateDescription, bind$0040_15.TeacherId, bind$0040_15.SecondaryTeacherIds, bind$0040_15.RegionId))]));
                    },
                }))]), (matchValue_12 == null) ? defaultOf() : matchValue_12)]);
            })))))))))))], ["children", reactApi.Children.toArray(Array.from(elems_38))])]))), createElement("div", createObj(ofArray([["style", {
                minHeight: 200,
            }], (elems_40 = [(el_102 = Field, createElement(el_102, createObj(toList(delay(() => append(singleton(["label", "Kommentar fra kursholder"]), delay(() => append(defaultArg(map_1((description) => {
                if (description.length > 5000) {
                    return ofArray([["validationMessage", `Kommentar kan ikke være lengre enn 5000 tegn (${description.length}/5000)`], ["validationState", "error"]]);
                }
                else {
                    return ofArray([["validationMessage", `${description.length}/5000`], ["validationState", "none"]]);
                }
            }, model_1.Form.Description), empty_1()), delay(() => {
                let matchValue_13, el_99;
                return singleton(["children", (matchValue_13 = tryHead([(el_99 = Textarea, createElement(el_99, {
                    resize: "vertical",
                    style: {
                        minHeight: 150,
                    },
                    value: defaultArg(model_1.Form.Description, ""),
                    onChange: (_arg_20, value_1_100) => {
                        let bind$0040_16;
                        dispatch(new Msg(0, [(bind$0040_16 = model_1.Form, new UpdatedEventForm(bind$0040_16.Name, bind$0040_16.Enabled, bind$0040_16.Summary, value_1_100.value, bind$0040_16.Address, bind$0040_16.MaxAttendees, bind$0040_16.Time, bind$0040_16.EndTime, bind$0040_16.SignupDeadline, bind$0040_16.DateDescription, bind$0040_16.TeacherId, bind$0040_16.SecondaryTeacherIds, bind$0040_16.RegionId))]));
                    },
                }))]), (matchValue_13 == null) ? defaultOf() : matchValue_13)]);
            })))))))))], ["children", reactApi.Children.toArray(Array.from(elems_40))])])))], ["children", reactApi.Children.toArray(Array.from(elems_41))])])))], ["children", reactApi.Children.toArray(Array.from(elems_42))])])))], ["children", reactApi.Children.toArray(Array.from(elems_43))])]))));
        }
        else {
            return singleton(createElement("div", createObj(ofArray([["style", {
                width: 100 + "%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                paddingBottom: 15,
            }], (elems_2 = [(el_12 = WarningRegular, createElement(el_12, {
                primaryFill: tokens.colorStatusWarningForeground1,
                fontSize: 82,
            })), (el_14 = Caption1, createElement(el_14, {
                children: "Noe gikk galt - vennligst prøv igjen senere",
            }))], ["children", reactApi.Children.toArray(Array.from(elems_2))])]))));
        }
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_44))])]))))], ["children", reactApi_1.Children.toArray(Array.from(elems_45))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_46))])]))), createElement("div", createObj(ofArray([["style", {
        padding: ((12 + "px ") + 18) + "px",
        borderTop: (((1 + "px ") + "solid") + " ") + tokens.colorNeutralStroke2,
        backgroundColor: tokens.colorNeutralBackground1,
        display: "flex",
        justifyContent: "flex-end",
        gap: 8 + "px ",
        flexShrink: 0,
    }], (elems_48 = [(el_108 = Button, createElement(el_108, {
        appearance: "secondary",
        children: "Avbryt",
        disabled: model_1.IsSending,
        onClick: (_arg_21) => {
            dispatch(new Msg(2, [false]));
            dispatch(new Msg(0, [initialForm]));
        },
    })), (el_114 = Button, createElement(el_114, createObj(ofArray([["appearance", "primary"], ["disabled", !canSubmit], ["onClick", (_arg_22) => {
        dispatch(new Msg(3, [true]));
        Promises_updateEvent(event.Id, model_1.Form, replaceEvent, dispatch, setCtx);
    }], (elems_47 = toList(delay(() => {
        let el_110, el_112;
        return model_1.IsSending ? singleton((el_110 = Spinner, createElement(el_110, {
            size: "tiny",
        }))) : singleton((el_112 = Text$, createElement(el_112, {
            children: "Lagre",
        })));
    })), ["children", reactApi_1.Children.toArray(Array.from(elems_47))])]))))], ["children", reactApi.Children.toArray(Array.from(elems_48))])])))], ["children", reactApi_1.Children.toArray(Array.from(elems_49))])]))))], (elemsToUse = ((length(elems_50) <= 2) ? elems_50 : take(2, elems_50)), ["children", reactApi_1.Children.toArray(elemsToUse)]))])));
}

//# sourceMappingURL=EditEvent.jsx.map
